import { PERIOD_ACCESS_TYPES } from 'utils/constants';
import { renderLimitedTimeAccess, renderPermanentAccess } from './NoteUtils';
import HighlightText from 'components/UI/Inputs/AIQAutocomplete/HighlightText';
import PropTypes from 'prop-types';
import styles from './Note.module.css';

function Note({ name, customNote, note, accessPeriod, searchTerm, inverted }) {
    const { accessType = '', startTime = '', endTime = '', weekdays = [], periodType = '' } = accessPeriod || {};

    const alertNameString = `${name ?? ''}${note && !customNote ? ': ' : ''}`;
    const isBanned = name === 'Banned';
    const isRenderLimitedTimeAccess = !isBanned && periodType !== 'NO_LIMIT';

    const containerClass = `${styles.note}${inverted ? ` ${styles['note--inverted']}` : ''}`;

    return (
        <div className={containerClass}>
            <p className={styles['note-text-wrapper']}>
                <span className={styles['note-name']}>
                    <HighlightText text={alertNameString} searchTerm={searchTerm} />
                </span>
                {!customNote && note ? (
                    <span className={styles['note-text']}>
                        <HighlightText text={note} searchTerm={searchTerm} />
                    </span>
                ) : null}
            </p>

            {customNote ? (
                <p className={styles['note-text-wrapper']}>
                    <span className={styles['note-name']}>
                        <HighlightText text="Note: " searchTerm={searchTerm} />
                    </span>
                    <span className={styles['note-text']}>
                        <HighlightText text={customNote} searchTerm={searchTerm} />
                    </span>
                </p>
            ) : null}

            {accessType ? (
                <p className={styles['note-date']}>
                    <span className={styles['note-name']}>Period Access:</span>
                    <span>
                        {PERIOD_ACCESS_TYPES[accessType]} {renderPermanentAccess(startTime, endTime)}
                    </span>
                </p>
            ) : null}

            {isRenderLimitedTimeAccess ? (
                <>
                    <span className={styles['note-name']}>Limited-time Access:</span>
                    <p className={styles.limited}>{renderLimitedTimeAccess(weekdays || [])}</p>
                </>
            ) : null}
        </div>
    );
}

Note.propTypes = {
    name: PropTypes.string,
    customNote: PropTypes.string,
    note: PropTypes.string,
    accessPeriod: PropTypes.shape({
        accessType: PropTypes.string,
        startTime: PropTypes.string,
        endTime: PropTypes.string,
        weekdays: PropTypes.arrayOf(PropTypes.object),
        periodType: PropTypes.string,
    }),
    searchTerm: PropTypes.string,
    inverted: PropTypes.bool,
};

export default Note;
